import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{useEffect, useState} from 'react'
import { Form, Input ,Select, Spin, message } from 'antd';
import {ButtonBase} from '@mui/material';
import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';

export default function MemberLimits() {

  const [loading,setLoading] = useState(false)
  const [loading2,setLoad2ing] = useState(false)
  const [loading3,setLoad3ing] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  
  console.log(Form.useForm())

  const fetchData = async () => {
    setLoad3ing(true);
    let res = await axios.get(`/info/getAmountPerBet`)
    let res2 = await axios.get(`/info/getCommission`)
    setLoad3ing(false);
    if(res.code != 200 && res2.code != 200) return;
    const {
      mix_parlay_max_amount_per_bet,
      mix_parlay_min_amount_per_bet,
      single_max_amount_per_bet,
      single_min_amount_per_bet,
      single_big_max_amount_per_match,
      single_small_max_amount_per_match
    } = res.data;
    form.setFieldsValue({
      mix_parlay_max_amount_per_bet,
      mix_parlay_min_amount_per_bet,
      single_max_amount_per_bet,
      single_min_amount_per_bet,
      single_big_max_amount_per_match,
      single_small_max_amount_per_match
    })
    const {
      nine_to_eleven_mix_parlay_commission,
      single_big_match_commission,
      single_small_match_commission,
      three_to_eight_mix_parlay_commission,
      two_mix_parlay_commission
    } = res2.data;
    form2.setFieldsValue({
      nine_to_eleven_mix_parlay_commission,
      single_big_match_commission,
      single_small_match_commission,
      three_to_eight_mix_parlay_commission,
      two_mix_parlay_commission
    })
  }

  useEffect(()=>{
    fetchData();
  },[])
  
  const onFinish = async (values) => {
    console.log("values",values);
    setLoading(true)

    let params = values;
    const data = await axios.put(`/bet/updateAmountPerBet`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoading(false)
    setOpenAlert(true)
  };

  const onFinish2 = async (values) => {
    console.log("values",values);
    setLoad2ing(true)

    let params = values;
    const data = await axios.put(`/bet/updateCommission`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoad2ing(false)
    setOpenAlert(true)
  };

  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
 
  return (
    <div
    css={css`
      /* background-color: #ffffff; */
      border-radius: 1rem;
      margin: 0 10rem;
      padding: 1rem;
    `}
  >
      {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
    <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
    <Spin spinning={loading3}>
    <div>
      <Form
        name="basic"
        form={form}
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Upper form={form}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
      <Form
        name="basic"
        form={form2}
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish2}
        autoComplete="off"
      >
        <Lower form={form2}/>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading2 ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
    </Spin>
  </div>
  );
}

const Upper = ({form}) =>{

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Parlay Max Amount Per Bet"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="mix_parlay_max_amount_per_bet"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Parlay Min Amount Per Bet"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="mix_parlay_min_amount_per_bet"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Max Amount Per Bet"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_max_amount_per_bet"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Min Amount Per Bet"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_min_amount_per_bet"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Big Max Amount Per member"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_big_max_amount_per_match"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Small Max Amount Per member"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_small_max_amount_per_match"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
    </div>
  );
}

const Lower = ({form}) =>{

  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Small Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_small_match_commission"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Single Big Match Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="single_big_match_commission"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
       
      
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="2 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="two_mix_parlay_commission"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="3 to 8 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="three_to_eight_mix_parlay_commission"
          style={{ padding: "0 0.4rem", color: "white" }}
        >
          <Input  size="large" />
        </Form.Item>
      </div>
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="9 to 11 Parlay Commission"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="nine_to_eleven_mix_parlay_commission"
          style={{ padding: "0 0.4rem", color: "white" }}          
        >
          <Input size="large" />
        </Form.Item>
      </div>
    </div>
  );
}